import { pulsZeit } from '@netcon-work/shared'
import { useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { cn } from '../lib/cn'
import { pulsOrt, usePuls } from '../lib/puls'
import { useAufgabenAllerWelten } from '../lib/welt'
import { useJetzt, zeitText } from './meintag/Puls'

/**
 * **Der laufende Puls, überall in Work** ([Z-22](../../../../docs/phasen/zusatz-22-fokus-puls.md)).
 *
 * Nils, 19.10.2026: *„den puls auch in den anderen ansichten anzeigen das man wieder hinwechseln
 * kann. am besten überall in work das ich das sehe (header oder so? wenn man einen aktiven puls
 * hat)"*.
 *
 * Steht in der {@link Topbar}, die jede Ansicht benutzt – also ohne Einzelfälle. Ohne Puls ist
 * hier nichts. Ein Klick führt nach „Mein Tag" in den Circle, Ansicht Puls (`/?puls=<Zeitstempel>`).
 *
 * **Der Tab-Titel hängt hier**, nicht am Circle: so trägt er die Uhr auf jeder Seite. `versteckt`
 * blendet nur die Marke aus (im Puls selbst stünde sie doppelt) – der Titel läuft weiter.
 */
export function PulsMarke({ versteckt = false }: { versteckt?: boolean }) {
  const { stand } = usePuls()
  const { aufgaben } = useAufgabenAllerWelten()
  const jetzt = useJetzt(!!stand)
  const navigate = useNavigate()
  const titel = stand ? (aufgaben.find((a) => a.id === stand.aktivId)?.title ?? '') : ''
  const z = stand ? pulsZeit(stand, jetzt) : null

  const urTitel = useRef(typeof document !== 'undefined' ? document.title : '')
  const tabTitel = z ? `${z.pausiert ? '⏸' : '⏱'} ${zeitText(z)} · ${titel}` : null
  useEffect(() => {
    if (tabTitel) document.title = tabTitel
    else document.title = urTitel.current
  }, [tabTitel])
  useEffect(() => {
    const ur = urTitel.current
    return () => {
      document.title = ur
    }
  }, [])

  if (!stand || !z || versteckt) return null
  return (
    <button
      type="button"
      onClick={() =>
        pulsOrt() === '/my-work'
          ? void navigate({ to: pulsOrt() as string })
          : void navigate({ to: '/', search: { puls: Date.now() } as never })
      }
      title="Zurück zum Fokus-Puls"
      className={cn(
        'flex max-w-full shrink-0 cursor-pointer items-center gap-2 rounded-full border bg-surface py-1 pr-1 pl-3 text-[13px] shadow-task',
        z.endspurt ? 'border-warn' : 'border-line',
      )}
    >
      <b className={cn('tabular shrink-0', z.ueberzogen && 'text-warn')}>
        {z.pausiert ? '⏸' : '⏱'} {zeitText(z)}
      </b>
      <span className="max-w-[180px] truncate text-ink2">{titel}</span>
      <span className="shrink-0 rounded-full bg-accent px-3 py-1 font-semibold text-white">
        Zum Puls
      </span>
    </button>
  )
}
